var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "info",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 20.5a8.75 8.75 0 1 0 0-17.5 8.75 8.75 0 0 0 0 17.5zm0-1.5a7.25 7.25 0 1 1 0-14.5 7.25 7.25 0 0 1 0 14.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 15.75v-4a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0zm-.735-8.67a1.25 1.25 0 1 1-.035.001h.035z"
  })));
};
export default SvgInfo;